import * as React from "react";
import isNumber from "lodash/isNumber";
import useReportingByAICustomization from "security-app/components/Investigations/AIReport/hooks/useInvestigationReportingByAICustomization";
import { Button } from "components/bootstrap";
import { Icon, HoverForHelp, Pluralize } from "components/common";
import AIReportModal from "security-app/components/Investigations/AIReport/AIReportModal";
import useDisclosure from "util/hooks/useDisclosure";
const MINIMAL_LOGS_TO_GENERATE_REPORT = 3;
const AIReportButton = ({
  investigation,
  small = false,
  logsCount
}) => {
  const [showAIReportModal, { open: openAIReportModal, close: closeAIReportModal }] = useDisclosure(false);
  const { enabled: enabledForBrand } = useReportingByAICustomization();
  const hasNotEnoughLogs = isNumber(logsCount) && logsCount < MINIMAL_LOGS_TO_GENERATE_REPORT;
  if (!enabledForBrand) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: hasNotEnoughLogs,
      bsStyle: "primary",
      onClick: openAIReportModal,
      title: "Generate AI Report",
      bsSize: small ? "sm" : void 0
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "note_add", type: "regular", size: small ? "sm" : void 0 }),
    " ",
    !small && "AI Report",
    hasNotEnoughLogs && /* @__PURE__ */ React.createElement(HoverForHelp, { title: "Add more logs" }, "At least ", MINIMAL_LOGS_TO_GENERATE_REPORT, " ", /* @__PURE__ */ React.createElement(Pluralize, { value: MINIMAL_LOGS_TO_GENERATE_REPORT, singular: "log evidence is", plural: "log evidences are" }), " ", "required to generate an AI report.")
  ), showAIReportModal && /* @__PURE__ */ React.createElement(AIReportModal, { onCancel: closeAIReportModal, investigation }));
};
export default AIReportButton;
